import React from 'react';
import ImageBasic from "../Common/Image/ImageBasic";
import {text} from "../../constants/text";
import {formatCurrency} from "../../utils";


export const OrderProduct = ({product, onDetailProduct}) => {
    const {thumbnail, productName, price, variantTitle, quantity, subtotal} = product || {}
    return (
        <div
            key={product?.id}
            onClick={onDetailProduct}
            className="flex justify-between items-center text-sm space-x-4 cursor-pointer px-4 py-3 md:py-4 border-b border-dashed border-gray-200 last:border-b-0">
            <div className="flex items-center space-x-4 w-full md:w-[60%]">
                <div className="min-w-20 h-20 relative">
                    <ImageBasic
                        className='w-20 h-20'
                        src={thumbnail}
                        alt={productName}
                    />
                </div>
                <div className="flex-1 text-sm">
                    <div className="line-clamp-2">{productName}</div>
                    <div className="flex justify-between items-center mt-2">
                    <span
                        className="text-gray-500">{`${text.unitPrice}: ${formatCurrency(price)}đ`}</span>
                    </div>
                    <div className="text-gray-500">{`${text.type}: ${variantTitle}`}</div>
                    <div className='md:hidden text-gray-500 flex justify-between items-center'>
                        <div>{`${text.quantity}: ${quantity}`}</div>
                        <div
                            className='min-w-[50px text-black text-right font-bold'>{`${formatCurrency(subtotal)}đ`}</div>
                    </div>
                </div>
            </div>
            <div className='hidden md:block'>{`${text.quantity}: ${quantity}`}</div>
            <div className="hidden md:block text-center">
                <p className="font-bold min-w-[50px] text-right">
                    {`${formatCurrency(subtotal)}đ`}
                </p>
            </div>
        </div>
    );
};